import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import * as LoginActionCreators from "../../../../actions/login.actions";
import { IAppState } from '../../../../app';
import { Redirect } from 'react-router';
import * as DTOS from "../../../../FeralScan.dtos";
import ContentContainer from '../../../Content/ContentContainer';
import InternalAbsoluteLink from '../Links/InternalAbsoluteLink';
import InternalClassificationLink from '../Links/InternalClassificationLink';
import { Link } from 'react-router-dom';

type PageAdminDashboardProps = {

}

type PageAdminDashboardActions = {
}

type PageAdminDashboardRouteParams = {
}

type PageAdminDashboardQueryParams = {
}

type PageAdminDashboardPropsMapped = {
}

type PageAdminDashboardActionsMapped = {
}

type PageAdminDashboardAllPropsInherited = PageAdminDashboardProps & PageAdminDashboardActions;
type PageAdminDashboardAllPropsMapped = PageAdminDashboardPropsMapped & PageAdminDashboardActionsMapped;

type PageAdminDashboardAllProps = IBasePageProps<PageAdminDashboardRouteParams, PageAdminDashboardQueryParams> & Partial<PageAdminDashboardAllPropsMapped> & PageAdminDashboardAllPropsInherited;

interface IPageAdminDashboardState {
}

class PageAdminDashboard extends React.Component<PageAdminDashboardAllProps, IPageAdminDashboardState> {
    constructor(props, context) {
        super(props, context);
    }
    render() {
        return (<div className="row m-3">
            <h2>Administration Dashboard</h2>
            <div className="w-100" />
            
            <div className="col-xl-3 col-md-5 col-12">
                <div className="card m-1">
                    <div className="card-body">
                        <h4 className="card-title mb-0"><i className="fa fa-user pr-2" />Users</h4>
                    </div>
                    <div className="list-group list-group-flush">
                        {InternalClassificationLink("admin/user", "Manage", "fa-edit pr-2", "list-group-item list-group-item-action")}
                        {InternalAbsoluteLink("api/admin/user/export", "Export Now", "fa-download pr-2", "list-group-item list-group-item-action", "blank")}
                    </div>
                </div>
            </div>

            <div className="col-xl-3 col-md-5 col-12">
                <div className="card m-1">
                    <div className="card-body">
                        <h4 className="card-title  mb-0"><i className="fa fa-sitemap pr-2" />Sites</h4>
                    </div>
                    <div className="list-group list-group-flush">
                        {InternalClassificationLink("admin/site", "Manage", "fa-edit pr-2", "list-group-item list-group-item-action")}
                        {InternalClassificationLink("admin/export/site", "Exports", "fa-download pr-2", "list-group-item list-group-item-action")}
                    </div>
                </div>
            </div>

            <div className="col-xl-3 col-md-5 col-12">
                <div className="card m-1">
                    <div className="card-body">
                        <h4 className="card-title  mb-0"><i className="fa fa-file pr-2" />Files</h4>
                    </div>
                    <div className="list-group list-group-flush">
                        {InternalClassificationLink("admin/file", "Manage", "fa-edit pr-2", "list-group-item list-group-item-action")}
                    </div>
                </div>
            </div>

            <div className="col-xl-3 col-md-5 col-12">
                <div className="card m-1">
                    <div className="card-body">
                        <h4 className="card-title  mb-0"><i className="fa fa-file pr-2" />Templates</h4>
                    </div>
                    <div className="list-group list-group-flush">
                        {InternalClassificationLink("admin/templates", "Manage", "fa-edit pr-2", "list-group-item list-group-item-action")}
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageAdminDashboardAllProps): PageAdminDashboardPropsMapped => {

    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageAdminDashboardActionsMapped>({
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageAdminDashboard);